module.exports = __webpack_public_path__ + "img/nx_v1_3.68ee2d9d.png";